import React from "react"
import AddressDisplay from "./address-display"

export default function ParameterDisplay({ type = "", values }) {
  if(!Array.isArray(values)) {
    values=[values]
  }
  return values?.map?.((value,index) => {
    if (!type) {
      if (String(value).length == 42) type = "address"
    }
    if (typeof value == "boolean" || type == "boolean")
      return value ? "true" : "false"
    if (type == "address") {
      return <AddressDisplay shorten key={index} address={value} />
    } if (type?.match?.(/bytes/) && String(value).length>10) {
      return <AddressDisplay shorten key={index} address={value} />
    } else {
      return value || <div />
    }
  })
}
